import { render, staticRenderFns } from "./HelloComposant.vue?vue&type=template&id=5d5e37d8&scoped=true&"
import script from "./HelloComposant.vue?vue&type=script&lang=js&"
export * from "./HelloComposant.vue?vue&type=script&lang=js&"
import style0 from "./HelloComposant.vue?vue&type=style&index=0&id=5d5e37d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e37d8",
  null
  
)

export default component.exports